import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpdxComponent } from './simple-icons-spdx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpdxComponent ],
    exports:      [ SimpleIconsSpdxComponent ],
    bootstrap:    []
})
export class SimpleIconsSpdxModule {}
